/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import api from 'middleware/api';
import cloudinary from 'middleware/cloudinary';
import facebook from 'middleware/facebook';
import google from 'middleware/google';
import wordpress from 'middleware/wordpress';
import reducers from 'reducers/reducers';

const enhancer = compose(
  applyMiddleware(thunk, api, cloudinary, facebook, google, wordpress)
);

const preloadedState = window.__PRELOADED_STATE__ || {};

const store = createStore(reducers, preloadedState, enhancer);

export default store;
